import AuthService from '../../utilities/services/auth.service'

import { ModalProvider } from '../../providers/ModalProvider/ModalProvider'
import { AssignInventoryWrapper } from '../../components'

export default function AssignInventoryPage() {
  const organization = AuthService.getOrg()[0]

  return (
    <ModalProvider>
      <AssignInventoryWrapper organization={organization} />
    </ModalProvider>
  )
}
